// Wrap each "section" in the sidebar mega menu's grandchild list inside its
// own .mega-section container, with the items separated from the header. This
// lets CSS use flexbox per-section layout where overflow items align below
// the header line (instead of floating at the very top of an empty column,
// which is what CSS multi-column does on its own).
//
// Detection: a section header is any direct <a> child of an <li> whose href
// ends with "#". The colleague entered these as placeholder URLs since
// Shopify's admin caps menus at 3 levels and the original menu had section
// labels at a 4th level. See navigation-section-headers.css for the visual
// styling that turns these into bold headers.

(function () {
  function processList(ul) {
    if (ul.dataset.sectionsWrapped === 'true') return;

    const items = Array.from(ul.children).filter(function (c) {
      return c.tagName === 'LI';
    });
    if (items.length === 0) return;

    const sections = [];
    let current = null;

    for (const li of items) {
      const link = li.querySelector(':scope > a');
      const href = link && link.getAttribute('href');
      const isHeader = !!(href && /#$/.test(href));

      if (isHeader) {
        current = { header: li, items: [] };
        sections.push(current);
      } else {
        if (!current) {
          current = { header: null, items: [] };
          sections.push(current);
        }
        current.items.push(li);
      }
    }

    if (sections.length === 0) return;

    ul.innerHTML = '';
    for (const sec of sections) {
      const sectionLi = document.createElement('li');
      sectionLi.className = 'mega-section';

      if (sec.header) sectionLi.appendChild(sec.header);

      const itemsUl = document.createElement('ul');
      itemsUl.className = 'mega-section__items';
      for (const itemLi of sec.items) itemsUl.appendChild(itemLi);
      sectionLi.appendChild(itemsUl);

      ul.appendChild(sectionLi);
    }

    ul.dataset.sectionsWrapped = 'true';
  }

  function init() {
    document
      .querySelectorAll('.mega-nav--sidebar .main-nav__grandchild')
      .forEach(processList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
